import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useScrollReveal from '../hooks/useScrollReveal';
import { projects } from '../utils/constants'; // Import from constants

const Work = ({ showToast }) => {
  useScrollReveal();

  // Scroll to top on mount/refresh
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="work-page">
      <section className="featured-section">
        <div className="page-title in-view">
          <h2>Our Work</h2>
          <p className="page-subtitle">Selected projects showcasing our expertise</p>
        </div>
        <div className="projects__grid">
          {projects.map(project => (
            <div className="project-card fade-in" key={project.id}>
              <div className="project-card__image">
                <img src={project.image} alt={project.title} loading="lazy" />
                <div className="project-card__overlay">
                  <Link 
                    to={`/projects/${project.id}`}
                    className="button"
                  >
                    View Case Study
                  </Link>
                </div>
              </div>
              <div className="project-card__content">
                <h3 className="project-card__title">{project.title}</h3>
                <p>{project.description}</p>
                <div className="project-card__tech">
                  {project.tags.map(tag => (
                    <span className="tech-tag" key={tag}>{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Work;